import script from "./EmailContentDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailContentDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./EmailContentDisplay.vue?vue&type=style&index=0&id=21f32638&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f32638"]])

export default __exports__